import { atom } from 'recoil';

export default atom({
  key: 'chordSize',
  default: 1,
});
